export default __webpack_public_path__ + "static/media/email.8ab6cce1.png";